<template>
  <Row>
    <Col span="12">
      <Input v-model="searchName" placeholder="请输入名称" class="public-inp" />
      <Select v-model="status" class="public-inp">
        <Option
          v-for="item in statusList"
          :value="item.value"
          :key="item.value"
          >{{ item.label }}</Option
        >
      </Select>
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        v-access="'brandInfo.query'"
        >搜索</Button
      >
      <Button @click="resetList()" v-access="'brandInfo.reset'">重置</Button>
    </Col>
    <Col span="12">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        @click="openFn()"
        v-access="'brandInfo.add'"
        >添加品牌</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="sort">
          <span v-show="false">{{ row.code }}</span>
          {{ (page - 1) * pageSize + index + 1 }}
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            v-access="'brandInfo.status'"
            :value="row.status == 0"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row }" slot="avatar">
          <Avatar :src="row.logoUrl" />
        </template>
        <template slot-scope="{ row }" slot="sortIndex">
          <a @click="openSort(row)" class="sort_index">{{ row.sortIndex }}</a>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="openFn(row, index)"
            v-access="'brandInfo.edit'"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(index, row)"
            v-access="'brandInfo.delete'"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增品牌' : '编辑品牌'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="名称" prop="name">
          <Input v-model="formItem.name" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="LOGO" prop="logoUrl">
          <Upload
            ref="upload"
            :show-upload-list="false"
            :action="uploadUrl"
            :data="uploadPram"
            :before-upload="beforeUpload"
            :on-success="(value) => handleSuccess(0, value)"
            :on-error="(value) => onError(0, value)"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048000"
            :headers="{ token: $sessionToken() }"
          >
            <Button icon="ios-cloud-upload-outline" :loading="uploading"
              >上传图片</Button
            >
          </Upload>
          <div v-if="formItem.logoUrl" :style="{ marginTop: '5px' }">
            <Avatar shape="square" size="large" :src="formItem.logoUrl" />
          </div>
          <div>仅支持jpg/png，图片比例为:1:1，建议尺寸：180*180，不超过2M</div>
        </FormItem>
        <FormItem label="C端icon" prop="iconUrl">
          <Upload
            ref="upload"
            :show-upload-list="false"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="(value) => handleSuccess(1, value)"
            :on-error="(value) => onError(1, value)"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048000"
            :headers="{ token: $sessionToken() }"
          >
            <Button icon="ios-cloud-upload-outline" :loading="uploading"
              >上传图片</Button
            >
          </Upload>
          <div v-if="formItem.iconUrl" :style="{ marginTop: '5px' }">
            <Avatar shape="square" size="large" :src="formItem.iconUrl" />
          </div>
          <div>仅支持jpg/png，图片比例为:1:1，建议尺寸：180*180，不超过2M</div>
        </FormItem>
        <FormItem label="C端详情图" prop="detailUrl">
          <Upload
            ref="upload"
            :show-upload-list="false"
            :action="uploadUrl"
            :before-upload="beforeUpload"
            :on-success="(value) => handleSuccess(2, value)"
            :on-error="(value) => onError(2, value)"
            :format="['jpg', 'jpeg', 'png']"
            :max-size="2048000"
            :headers="{ token: $sessionToken() }"
          >
            <Button icon="ios-cloud-upload-outline" :loading="uploading"
              >上传图片</Button
            >
          </Upload>
          <div v-if="formItem.detailUrl" :style="{ marginTop: '5px' }">
            <Avatar shape="square" size="large" :src="formItem.detailUrl" />
          </div>
          <div>仅支持jpg/png，图片比例为:1:1，建议尺寸：180*180，不超过2M</div>
        </FormItem>
        <FormItem label="描述">
          <Input
            v-model="formItem.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入描述"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 修改排序 -->
    <Modal
      v-model="formSort"
      title="修改序号"
      :loading="formSortLoading"
      :mask-closable="false"
      @on-ok="sortUpdate"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidateSort"
        :model="formSortItem"
        :rules="ruleValidateSort"
        :label-width="120"
      >
        <FormItem label="原序号"> {{ formSortItem.oldIndex }}</FormItem>
        <FormItem label="更新后的序号" prop="sortIndex">
          <Input
            v-model="formSortItem.sortIndex"
            placeholder="请输入更新后的序号"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
  </Row>
</template>
<script>
import axios from "axios";
const columns = [
  {
    title: "序号",
    slot: "sort",
    width: 60,
  },
  {
    title: "品牌名称",
    key: "name",
  },
  {
    title: "品牌图片",
    slot: "avatar",
  },
  {
    title: "排序",
    slot: "sortIndex",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "描述",
    key: "remark",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
const statusList = [
  {
    label: "全部",
    value: "",
  },
  {
    label: "禁用",
    value: "1",
  },
  {
    label: "启用",
    value: "0",
  },
];
const validateSelfHandler = (msg, rule, value, callback) => {
  if (new RegExp(rule).test("" + value)) {
    callback();
  } else {
    callback(new Error(msg));
  }
};
export default {
  data() {
    return {
      loading: false,
      columns,
      tbList: [],
      searchName: "",
      status: "",
      statusList,
      page: 1,
      pageSize: 10,
      total: 0,
      formModel: false,
      formModalLoading: true,
      formTitle: 0,
      formItemCode: "",
      formItem: {
        name: "",
        logoUrl: "",
        remark: "",
        iconUrl: "",
        detailUrl: "",
      },
      uploadPram: {
        scene: "SHOP",
      },
      uploadUrl: "",
      uploading: false,
      ruleValidate: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        logoUrl: [{ required: true, message: "请上传图片", trigger: "change" }],
        iconUrl: [{ required: true, message: "请上传图片", trigger: "change" }],
        detailUrl: [
          { required: true, message: "请上传图片", trigger: "change" },
        ],
      },
      // 新增修改序号弹框
      formSort: false,
      formSortLoading: true,
      formSortItem: {
        code: "",
        sortIndex: "",
        oldIndex: "",
      },
      ruleValidateSort: {
        sortIndex: [
          { required: true, message: "请输入序号~", trigger: "change" },
          {
            required: true,
            type: "number",
            validator: (rule, value, callback) =>
              validateSelfHandler("请输入数字", /^\d+$/, value, callback),
            trigger: "blur",
          },
        ],
      },
    };
  },
  watch: {
    formModel(newv, oldv) {
      if (!newv) {
        this.formItem = {
          name: "",
          logoUrl: "",
          remark: "",
          iconUrl: "",
          detailUrl: "",
        };
      }
    },
  },
  created() {
    this.uploadUrl = axios.defaults.baseURL + "base/file/publicUpload";
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      let data = {
        name: this.searchName,
        page: this.page,
        pageSize: this.pageSize,
        status: this.status,
      };
      this.loading = true;
      this.$api.brandSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          let list = res.data;
          if (!list || list.length == 0) {
            this.tbList = [];
            return;
          }
          this.tbList = list;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.searchName = "";
      this.page = 1;
      this.pageSize = 10;
      this.status = "";
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        this.formItem = {
          name: d.name,
          logoUrl: d.logoUrl,
          remark: d.remark,
          iconUrl: d.iconUrl,
          detailUrl: d.detailUrl,
        };
        this.formItemCode = d.code;
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 新增编辑确定
    addAction() {
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
      let data = this.formItem;
      //   新增
      let http = "brandAdd";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.formTitle == 1) {
            data.code = this.formItemCode;
            http = "brandUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.resetList();
            }
          });
        }
      });
    },
    cancelAction() {
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
      this.$refs["formValidateSort"].resetFields();
      this.formSort = false;
    },
    // 删除部门
    removeFn(i, d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.name}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.brandDelete({ code: d.code }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.resetList();
            }
          });
        },
      });
    },
    // 状态
    stateChange(v, d, i) {
      let http = d.status == 0 ? "brandDisable" : "brandEnable";
      this.$api[http]({ code: d.code }).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
    beforeUpload(d) {
      let size = d.size;
      let type = d.type;
      if (size > 2048000) {
        this.$Message.error("图片不可大于2M");
        return false; //停止上传
      }
      if (type != "image/png" && type != "image/jpg" && type != "image/jpeg") {
        this.$Message.error("仅支持jpg/png");
        return false; //停止上传
      }
      this.uploading = true;
    },

    handleSuccess(index, value) {
      this.uploading = false;
      let data = value.data;
      switch (index) {
        case 0:
          this.formItem.logoUrl = data.url;
          break;
        case 1:
          this.formItem.iconUrl = data.url;
          break;
        case 2:
          this.formItem.detailUrl = data.url;
          break;
        default:
          break;
      }
    },

    onError(index, value) {
      switch (index) {
        case 0:
          this.formItem.logoUrl = "";
          break;
        case 1:
          this.formItem.iconUrl = "";
          break;
        case 2:
          this.formItem.detailUrl = "";
          break;
        default:
          break;
      }
      //   this.formItem.logoUrl = "";
      this.uploading = false;
      this.$Message.error("上传失败");
    },

    // 更新updateSort
    openSort(value) {
      this.formSortItem = {
        code: value.code,
        oldIndex: value.sortIndex,
      };
      this.$nextTick(() => {
        this.formSort = true;
      });
    },
    sortUpdate() {
      this.formSortLoading = false;
      this.$nextTick(() => {
        this.formSortLoading = true;
      });
      let data = {
        code: this.formSortItem.code,
        sortIndex: this.formSortItem.sortIndex,
      };
      this.$refs["formValidateSort"].validate((valid) => {
        if (valid) {
          this.$api.brandSort(data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.resetList();
            }
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/commodity/brandInfo.vue